/* eslint-disable no-console */

const LOG_LEVELS = {
    verbose: 0,
    debug: 1,
    info: 2,
    log: 2, // alias for 'info'
    warn: 3,
    low: 4,
    med: 5,
    high: 6,
    crit: 7,
    error: 7, // alias for 'crit'
};

const getLogLevel = () => {
    const matches = (/(?:^|; )LOG_LEVEL=([^;]*)/).exec(document.cookie);
    return matches ? matches[1] : null;
};

const logger = Object.keys(LOG_LEVELS).reduce((acc, level) => {
    acc[level] = (...args) => {
        if (LOG_LEVELS[getLogLevel()] <= LOG_LEVELS[level]) {
            if (LOG_LEVELS[level] >= LOG_LEVELS['low']) {
                console.error(...args);
            } else if (LOG_LEVELS[level] >= LOG_LEVELS['warn']) {
                console.warn(...args);
            } else {
                console.log(...args);
            }
        }
    };
    return acc;
}, {});

logger.verbose('LOG_LEVEL set to ' + getLogLevel());

export default logger;